/** Semáforo de confianza por campo del parser (verde/amarillo/rojo) — explicable: muestra motivos al pasar el ratón. */
const LABEL = { tipo_trabajo: "Tipo trabajo", espacio: "Espacio", componentes: "Componentes", cantidades_medidas: "Cant./medidas", fechas_permisos: "Fechas/permisos", cliente: "Cliente" };
const CLS = {
  verde: "bg-emerald-500/15 text-emerald-200 border-emerald-500/30",
  amarillo: "bg-amber-500/20 text-amber-100 border-amber-500/40",
  rojo: "bg-rose-500/20 text-rose-100 border-rose-500/40",
};

export default function ConfianzaCampos({ confianzas, compact = false }) {
  if (!confianzas || !Object.keys(confianzas).length) return null;
  const dudosos = Object.values(confianzas).filter((c) => c.nivel !== "verde").length;
  return (
    <div className="space-y-1" data-testid="confianza-campos">
      {!compact && (
        <div className="text-[11px] text-zinc-400">
          Confianza IA por campo · {dudosos ? <span className="text-amber-300">{dudosos} campo(s) a revisar</span> : <span className="text-emerald-300">todo en verde</span>}
        </div>
      )}
      <div className="flex flex-wrap gap-1">
        {Object.entries(confianzas).map(([k, c]) => (
          <span key={k} title={(c.motivos || []).join(" · ") || "sin avisos"} data-testid={`confianza-${k}`}
            className={`text-[10px] px-1.5 py-0.5 rounded border ${CLS[c.nivel] || CLS.amarillo}`}>
            {LABEL[k] || k} {Math.round((c.score || 0) * 100)}%
          </span>
        ))}
      </div>
    </div>
  );
}
